import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=a4aff062"
import script from "./GroupEdit.vue?vue&type=script&lang=ts"
export * from "./GroupEdit.vue?vue&type=script&lang=ts"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=a4aff062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports